let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRWrb")).then(() => parcelRequire('aL23w'));